<template>
  <div class="wrap">
    <van-search
      v-if="status"
      @input="input"
      @focus="focusinputFun"
      v-model="value"
      shape="round"
      left-icon="https://img.zai-art.com/zaiart/saas/image/md/112644a0780989204764b3ee98418c2e.png"
      placeholder="请输入关键词进行搜索"
    />
    <van-tabs
      style="z-index:10"
      v-if="status && status.length"
      :swipe-threshold="status.length"
      @click="toggle"
      v-model="selectedState"
      color="#222"
      title-active-color="#222"
      title-inactive-color="#999"
      sticky
    >
      <van-tab v-for="(item, inx) in status" :title="item.label" :key="inx" :name="item.value">
        <van-tabs
          class="childrenvan-tabs__line"
          @click="childrentab"
          line-height="0"
          title-active-color="#222"
          title-inactive-color="#999"
          v-if="childrenStatus && childrenStatus.length && !childrenStatushide"
          v-model="childrenselectedState"
        >
          <van-tab
            v-for="(it, its) in childrenStatus"
            :key="its"
            :title="it.label"
            :name="it.value"
          ></van-tab>
        </van-tabs>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-checkbox-group checked-color="#333333" v-model="multipleSelection">
              <div
                v-for="(item, index) in list"
                :key="index"
                class="listItem"
                :class="isCheckbox ? 'listItemNoMargin' : ''"
              >
                <div class="section">
                  <div v-if="isCheckbox" class="vancheckout">
                    <van-checkbox :name="item" ref="checkboxes"></van-checkbox>
                  </div>
                  <div class="thumb">
                    <img
                      :src="
                        item.imageUrl + '?imageView2/1/w/86/h/86' ||
                          $lodash.get(item, option.optionIMg)
                      "
                      alt=""
                    />
                  </div>
                  <div class="content">
                    <slot :data="item" name="content"></slot>
                  </div>
                </div>
                <div
                  v-if="(option.moreButtons && option.moreButtons.length) || option.isButtons"
                  class="btnbox vanpopoverClass"
                >
                  <div class="more">
                    <van-popover
                      v-if="option.moreButtons && option.moreButtons.length"
                      :placement="
                        list.length > 0 && list.length - 1 == index ? 'top-start' : 'bottom-start'
                      "
                      :get-container="getContainer"
                      v-model="item[item.id]"
                      trigger="click"
                    >
                      <div class="popoverbtnbox">
                        <template v-for="b in option.moreButtons" >
                          <template v-if="b.computed">
                            <div
                              :key="b"
                              @click="b.onClick(index, item)"
                              class="popoverbtn"
                              v-show="b.computed(index,item)"
                            >
                              {{ b.value }}
                            </div>
                          </template>
                          <template v-else>
                             <div
                                :key="b"
                                @click="b.onClick(index, item)"
                                class="popoverbtn"
                              >
                                {{ b.value }}
                              </div>
                          </template>
                         
                      
                        </template>
                        <!-- <div
                          v-for="(b, i) in option.moreButtons"
                          :key="i"
                          @click="b.onClick(index, item)"
                          class="popoverbtn"
                          v-if="b.computed(index,item)"
                        >
                          {{ b.value }}
                          {{ item.status }}
                        </div> -->
                      </div>
                      <template #reference>
                        <span>更多</span>
                      </template>
                    </van-popover>
                  </div>
                  <div class="rightbtn">
                    <slot :data="item" :index="index" name="buttons"></slot>
                    <!-- <div class="btn">测1试开播</div>
                  <div class="btn">测试开播</div> -->
                  </div>
                </div>
              </div>
            </van-checkbox-group>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <template v-else-if="!status">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-checkbox-group checked-color="#333333" v-model="multipleSelection">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="listItem 666"
              :class="isCheckbox ? 'listItemNoMargin' : ''"
            >
              <div class="section">
                <div v-if="isCheckbox" @click="checkboxtoggle(index, item)" class="vancheckout">
                  <van-checkbox :name="item" ref="checkboxes"></van-checkbox>
                </div>
                <div class="thumb">
                  <img :src="item.imageUrl || $lodash.get(item, option.optionIMg)" alt="" />
                </div>
                <div class="content">
                  <slot :data="item" name="content"></slot>
                </div>
              </div>
              <div
                v-if="(option.moreButtons && option.moreButtons.length) || option.isButtons"
                class="btnbox vanpopoverClass"
              >
                <div class="more">
                  <van-popover
                    v-if="option.moreButtons && option.moreButtons.length"
                    :placement="
                      list.length > 0 && list.length - 1 == index ? 'top-start' : 'bottom-start'
                    "
                    :get-container="getContainer"
                    v-model="item[item.id]"
                    trigger="click"
                  >
                    <div class="popoverbtnbox">
                      <div
                        v-for="(b, i) in option.moreButtons"
                        :key="i"
                        @click="b.onClick(index, item)"
                        class="popoverbtn"
                      >
                        {{ b.value }}
                      </div>
                    </div>
                    <template #reference>
                      <span>更多</span>
                    </template>
                  </van-popover>
                </div>
                <div class="rightbtn">
                  <slot :data="item" :index="index" name="buttons"></slot>
                  <!-- <div class="btn">测1试开播</div>
                  <div class="btn">测试开播</div> -->
                </div>
              </div>
            </div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
    </template>
    <div v-if="option.fixButtons && option.fixButtons.length" class="fixbtn">
      <template v-for="(item, index) in option.fixButtons">
        <div
          v-if="item.type == 'live'"
          :key="index"
          class="btn"
          :class="index % 2 == 0 ? 'one' : 'two'"
          @click="item.onClick()"
        >
          立即<br />{{ item.value }}
        </div>
        <div
          v-else-if="item.type == 'add'"
          :key="index"
          class="btn"
          :class="index % 2 == 0 ? 'one' : 'two'"
          @click="item.onClick()"
        >
          新增<br />{{ item.value }}
        </div>
        <div
          v-else-if="item.type == 'test'"
          :key="index"
          class="btn"
          :class="index % 2 == 0 ? 'one' : 'two'"
          @click="item.onClick()"
        >
          测试<br />{{ item.value }}
        </div>
        <div
          v-else
          :key="index"
          class="btn"
          :class="index % 2 == 0 ? 'one' : 'two'"
          @click="item.onClick()"
        >
          创建<br />{{ item.value }}
        </div>
      </template>
    </div>
    <!-- isCheckbox  多选时候 的确定按钮 -->
    <div v-if="isCheckbox" class="isCheckbox">
      <button @click="handleOldSelectDatas" class="button">确定</button>
    </div>
    <share-image :detail="detail" ref="shareImage" @clear="clear"></share-image>
  </div>
</template>
<script>
import { Toast } from 'vant';
import shareImage from './shareImage';

export default {
  name: 'other',
  components: { shareImage },
  props: {
    option: { type: Object },
    remote: { type: Object }, // 接口
    status: { type: Array }, //状态
    childrenStatus: { type: Array }, //二级筛选状态栏
    isCheckbox: { type: Boolean, default: false }, //是否多选
    searchName: { type: String, default: 'name' },
    detail: { type: Object, default: {} },
  },
  data() {
    return {
      focusinput: false,
      loading: false,
      finished: false,
      param: null,
      value: null,
      selectedState: null, //99为全部
      childrenselectedState: null, //二级筛选菜单
      refreshing: false,
      list: [],
      showPopover: false,
      actions: [{ text: '编辑' }],
      multipleSelection: [], //多选存放
      childrenStatushide: true, //拍品列表子集菜单根据状态隐藏
    };
  },
  // computed:{
  //   detailShare(){
  //     console.log(this.detail)
  //     return this.detail
  //   }
  // },
  // watch: {
  //   detail: {
  //     handler(value, oldVal) {
  //       console.log(value )
  //       console.log(oldVal )
  //     },
  //     immediate: true,
  //   },
  // },
  created() {
    this.param = this.remote.param;
    // this.init();
  },
  methods: {
    onLoad() {
      // this.loading = true; //两个加载圈，注释一下
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '...',
      });
      this.remote &&
        this.remote
          .fetch(this.param)
          .then(res => {
            let tmpList = res.data.list || [];
            let list = this.list || [];
            if (this.refreshing) {
              list = tmpList;
              this.refreshing = false;
            } else if (tmpList.length) {
              list = [...list, ...tmpList];
            } else {
              this.finished = true;
            }
            this.loading = false;
            this.list = list;
            if (res.data.next) {
              this.param.page.index = res.data.next.index;
            } else {
              this.param.page.index++;
            }

            Toast.clear();
          })
          .catch(error => {
            Toast.clear();
          });
    },
    toggle() {
      this.param[this.option.statusKey] = this.selectedState == '99' ? null : this.selectedState;
      if (this.option.childrenStatushide && this.param[this.option.statusKey] != '0') {
        this.childrenStatushide = true;
        this.param[this.option.childrenStatusKey] = null;
        this.childrenselectedState = '99';
      } else {
        this.childrenStatushide = false;
        this.childrenselectedState = '99';
      }
      this.list = [];
      this.loading = true; //下拉加载中
      this.finished = false; //下拉结束
      this.param.page = { index: '1', size: 10 };
      if (this.loading) {
        this.onLoad();
      }
    },
    childrentab() {
      this.param[this.option.childrenStatusKey] =
        this.childrenselectedState == '99' ? null : this.childrenselectedState;
      this.list = [];
      this.loading = true; //下拉加载中
      this.finished = false; //下拉结束
      this.param.page = { index: '1', size: 10 };
      if (this.loading) {
        this.onLoad();
      }
    },
    onRefresh() {
      this.list = [];
      this.refreshing = false; //两个加载圈，改为false
      this.finished = false;
      this.loading = true; //下拉加载中
      this.param.page = { index: '1', size: 10 };
      this.onLoad();
    },
    del(index, msg) {
      Toast(msg);
      this.list.splice(index, 1);
    },
    getContainer() {
      return document.querySelector('vanpopoverClass');
    },
    focusinputFun() {
      this.focusinput = true;
    },
    //查询
    input() {
      if (!this.focusinput) {
        return;
      }
      console.log(this.value);
      this.list = [];
      this.param[this.searchName] = this.value ? this.value : null;
      this.param.page = { index: '1', size: 10 };
      this.onLoad();
    },
    handleOldSelectDatas() {
      this.$store.state.app.multipleSelection = this.multipleSelection;
      this.$emit('selectcheckData', this.multipleSelection);
    },
    clear() {
      this.$parent.detail = null;
    },
    checkboxtoggle(index, item) {
      this.$emit('checkouted', index, item);
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  .fixbtn {
    position: fixed;
    right: 20px;
    bottom: 64px;
    z-index: 999;
    .btn {
      width: 52px;
      height: 52px;
      background: #ff5757;
      box-shadow: 0px 2px 10px 0px rgba(255, 64, 64, 0.34);
      filter: blur(0px);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 50%;
      margin-bottom: 13px;
      // &:last-child {
      //   background: #3276fc;
      //   box-shadow: 0px 2px 10px 0px rgba(56, 126, 252, 0.34);
      // }
    }
    .one {
      background: #ff5757;
    }
    .two {
      background: #3276fc;
    }
    .btn.one {
      // background: #3276fc;
      // box-shadow: 0px 2px 10px 0px rgba(56, 126, 252, 0.34);
    }
  }
  .isCheckbox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 999;
    padding-bottom: env(safe-area-inset-bottom);
    height: 54px;
    padding: 5px 0;
    .button {
      width: 89.33%;
      height: 100%;
      background: #222222;
      border-radius: 4px;
      margin: 0 auto;
      display: block;
      color: #fff;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
  }
}
.listItem {
  background: #fff;
  margin-bottom: 10px;
  &:first-child {
    border-top: 1px solid #e5e5e5;
  }
  .section {
    padding: 20px;
    display: inline-flex;
    border-bottom: 1px solid #eeeeee;
    width: 100%;
    .vancheckout {
      width: 30px;
      // min-width: 30px;
      display: flex;
      align-items: center;
    }
    .thumb {
      width: 86px;
      height: 86px;
      margin-right: 12px;
      // min-width: 86px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .content {
      flex: 1;
      position: relative;
      display: inline-grid;
    }
  }
  .btnbox {
    background: #fff;
    padding: 9px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    .rightbtn {
      display: flex;
      justify-content: flex-end;
      .btn {
        width: 85px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #c8c8c8;
        margin-left: 10px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &:last-child {
          border: 1px solid #222222;
          color: #222222;
        }
      }
    }
  }
}
.listItemNoMargin {
  margin-bottom: 0;
  border: none;
  .section {
    border: none;
  }
}
</style>
<style lang="less">
.popoverbtnbox {
  background: #fff;
  .popoverbtn {
    width: 84px;
    height: 45px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 45px;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
    &:last-child {
      border: none;
    }
  }
}
.childrenvan-tabs__line {
  .van-tabs__line {
    display: none;
  }
}
.wrap .van-field__left-icon .van-icon {
  line-height: initial;
}
.wrap .van-list {
  min-height: 70vh;
}
</style>
